package com.mps.asc_app.data.bookings

import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime
import kotlin.time.Instant


@Serializable
enum class BookingKind {
    BOOKING,
    BLOCKED,
}

@Serializable
enum class BookingScope {
    SELF,
    TRAINING,
}

@OptIn(ExperimentalTime::class)
@Serializable
data class Bookings (
    val id: String,
    val courtId: String,
    val slotsTs: Instant,
    val kind: BookingKind = BookingKind.BOOKING,
    /** Nur gesetzt wenn kind == BLOCKED */
    val blockedComment: String? = null,
    val ownerUserId: String? = null,
    val bookingScope: BookingScope = BookingScope.SELF,
    val trainingGroupId: String? = null,
    val bookingplayers: List<BookingPlayer>,
    val maxPlayers: Int = 4,
    val minPlayers: Int = 2,
)